import DataStore from "../DataStore";
import {makeEl} from "../../common/Utils";
import {langType} from "../../interface/IFooter";
import {svgIcoBtnChange, svgIcoChangeList} from "../SvgCode";
import Layer from "../Layer";

export default class Language{
    private ds: DataStore;
    private btn!: HTMLButtonElement;
    private ul!: HTMLUListElement;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        if(this.ds.config.languageList.length> 0) {
            this.templ(_wrapper);
            this.addEvents();
        }
    }

    templ(_parent: HTMLElement){
        const tmpl = makeEl('div', _parent, {class: 'footer-change-inner footer-change-language'});
        this.btn = makeEl('button', tmpl, {class:'btn-footer-change'});

        this.btn.innerHTML= `
        <span class="inner-txt">${this.ds.l10nLang[this.ds.lang]}</span>
        ${svgIcoBtnChange}
        `

        this.ul = makeEl('ul', tmpl, {class: 'footer-change-list', id: 'FooterLanguageChangeList'});
        this.ds.config.languageList.map(it => this.liTempl(this.ul, it, svgIcoChangeList));
    }

    liTempl(_parent: HTMLUListElement, _data: langType, _svgCode: string){
        const li = makeEl('li', _parent, {class: 'footer-change-item'});
        const aEl = makeEl('a', li, {class: 'change-item-link', href: this.makeLink(_data), 'data-language': _data});

        if(_data === this.ds.lang){
            aEl.innerHTML= _svgCode;
            makeEl('strong', aEl, undefined, this.ds.l10nLang[_data]);
        }
        else{
            makeEl('span', aEl, undefined, this.ds.l10nLang[_data]);
        }
    }

    makeLink(_lang: string): string{
        const originSearch = location.search;
        const originSearchArray = originSearch.substring(1).split('&');

        let resultSearch = `locale=${_lang}-${this.ds.country}`;

        if(originSearch !== ''){
            for(let i=0; i<originSearchArray.length;i++){
                if(!originSearchArray[i].includes('locale')){
                    resultSearch += '&' + originSearchArray[i];
                }
            }
        }

        return `${window.location.pathname}?${resultSearch}`;
    }

    addEvents(){
        this.btn.addEventListener('click', e => {
            Layer.toggleLayer(this.ul.id);
            e.stopPropagation();
        });
    }
}